export default {
  title_operation: {
    fr: 'Directrice des opérations',
    en: 'Operations director',
  },
  title_tech: {
    fr: 'Directeur des technologies',
    en: 'Technology director',
  },
  title_marketing: {
    fr: 'Directeur marketing',
    en: 'Marketing director',
  },
  title_conception: {
    fr: 'Responsable de la conception',
    en: 'Conception manager',
  },
  title_design: {
    fr: 'Conseillère en design',
    en: 'Design consultant',
  },
  title_support: {
    fr: 'Support',
    en: 'Support',
  },
};
